import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import lifeLineService from "../../services/api/Lifeline";

const handleError = (err) => {
  console.error("[handleError] Error in Lifeline order details actions", err);
};

export const setOrderDetails = (payload) => {
  return {
    type: ActionTypes.SET_LIFELINE_ORDER_DETAILS,
    payload: payload,
  };
};

export const getLifeLineOrderDetails =
  (filter_type, filter_value) => async (dispatch) => {
    try {
      dispatch(setLoader(true));
      let queryParam = `filter_type=${filter_type}&filter_value=${encodeURIComponent(
        filter_value
      )}`;
      const response = await lifeLineService.getLifeLineOrderDetails(
        queryParam
      );
      dispatch(setLoader(false));
      if (response) {
        dispatch(setOrderDetails(response));
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getLifelineCallLogs = (orderId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let queryParam = `order_id=${orderId}`;
    const response = await lifeLineService.getLifelineCallLogs(queryParam);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const ConnectOutgoingCall =
  (ReceiverType, phoneNumber, orderId, ReceiverId) => async (dispatch) => {
    try {
      let body = {
        receiver_type: ReceiverType,
        phone_no: phoneNumber,
        order_id: orderId,
        receiver_id: ReceiverId,
      };
      dispatch(setLoader(true));
      let response = await lifeLineService.connectOutgoingCall(body);
      dispatch(setLoader(false));
      if (response) {
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const OrderActions =
  (action, orderId, reasonId, comments) => async (dispatch) => {
    try {
      let body = {
        action: action,
        order_id: orderId,
        reason_id: reasonId,
        comments: comments,
      };
      dispatch(setLoader(true));
      let response = await lifeLineService.orderActions(body);
      dispatch(setLoader(false));
      if (response) {
        return response;
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const ActionReasons = () => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await lifeLineService.orderActionReasons();
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const addSupportTags = (orderID, tagIDs) => async (dispatch) => {
  try {
    let body = {
      order_id: orderID,
      tag_ids: tagIDs,
    };
    dispatch(setLoader(true));
    const response = await lifeLineService.addSupportTags(body);
    dispatch(setLoader(false));
    if (response) {
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR,
      })
    );
    handleError(err);
  }
};
